import React from 'react';
import { RoleDescription, RoleList } from '@scale/shared/corp/projectRoles';
import { makeStyles } from 'design-system/styles';

const GetRoleDescriptions = () => {
  const styles = useStyles();
  return (
    <div className={styles.roleText}>
      {RoleList.map(role => (
        <div key={role.role} style={{ padding: 3 }}>
          <b>{RoleDescription[role.role].label}</b>: {RoleDescription[role.role].helpText} <br />
        </div>
      ))}
    </div>
  );
};

export default GetRoleDescriptions;

const useStyles = makeStyles({
  roleText: {
    padding: '10px 20px 10px 20px',
    fontSize: 12,
    background: 'var(--color-RemoGray01)',
  },
});
